import type { DroneEntity } from '@src/core/features';
import { useGetUserDataQuery } from '@src/core/features/profile/redux/api';
import { useGetHubsQuery } from '@src/features/hubs/redux/api';

export function useHubName(drone: DroneEntity | null | undefined): string {
  const { data: user } = useGetUserDataQuery();
  const { data: hubs = [] } = useGetHubsQuery();

  if (!drone) return '—';

  const fromDrone = drone.hubName ?? drone.hub?.name;
  if (fromDrone) return fromDrone;

  const hubId = drone.hubId ?? drone.hub?.id;
  if (hubId != null) {
    const fromHubs =
      hubs.find((h) => h.id === hubId)?.name ??
      user?.hubs?.find((h) => h.id === hubId)?.name;
    if (fromHubs) return fromHubs;
  }

  return '—';
}
